export function scriptTypeChange (value) {
  let lang = ''
  if (value === 'shell' || value === 'python' || value === 'go' || value === 'winps1') {
    lang = value
  } else if (value === 'linuxyml' || value === 'winyml') {
    lang = 'yaml'
  } else {
    lang = 'shell'
  }
  return lang
}

export function getJsonLength (jsonData) {
  return Object.keys(jsonData).length
}

export let cmOptions = {
  mode: {
    name: 'shell'
  },
  lineNumbers: true,
  matchBrackets: true,
  styleActiveLine: true,
  indentUnit: 4,
  lineWrapping: true,
  theme: 'monokai',
  keyMap: 'sublime',
  smartIndent: false,
  autoRefresh: true,
  foldGutter: true,
  autoCloseBrackets: true,
  cursorHeight: 0.85,
  showCursorWhenSelecting: true,
  // 在行槽中添加行号显示器、折叠器、语法检测器
  gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
  // 快捷键
  extraKeys: {
    'Ctrl': 'autocomplete',
    'F11': function (cm) {
      cm.setOption('fullScreen', !cm.getOption('fullScreen'))
    },
    'Esc': function (cm) {
      if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
    }
  }
}
